module.exports = __webpack_public_path__ + "static/media/quintus.462c24cd.png";